"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBillVendorTaxParsedRequest = exports.transformBillVendorTaxParsedResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Date_1 = require("./Date");
function transformBillVendorTaxParsedResponse(tax) {
    return {
        vendorId: tax.vendorid,
        taxId: tax.tax_id,
        systemTaxid: tax.system_taxid,
        enabled: tax.enabled,
        name: tax.name,
        amount: tax.amount,
        taxAuthorityid: tax.tax_authorityid,
        createdAt: tax.created_at && (0, Date_1.transformDateResponse)(tax.created_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        updatedAt: tax.updated_at && (0, Date_1.transformDateResponse)(tax.updated_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
    };
}
exports.transformBillVendorTaxParsedResponse = transformBillVendorTaxParsedResponse;
function transformBillVendorTaxParsedRequest(tax) {
    return {
        vendorid: tax.vendorId,
        tax_id: tax.taxId,
        system_taxid: tax.systemTaxid,
        enabled: tax.enabled,
        tax_authorityid: tax.taxAuthorityid,
    };
}
exports.transformBillVendorTaxParsedRequest = transformBillVendorTaxParsedRequest;
//# sourceMappingURL=BillVendorTax.js.map